import { render, staticRenderFns } from "./DiabetesKnowledgeCategories.vue?vue&type=template&id=e208d914"
import script from "./DiabetesKnowledgeCategories.vue?vue&type=script&lang=js"
export * from "./DiabetesKnowledgeCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports